import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Feed",
  "use": "Feed-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Feed\"><path d=\"M174.421 578.304a42.667 42.667 0 0 1-31.36-71.595L480.64 140.8a42.667 42.667 0 0 1 62.72 0l337.579 365.91a42.667 42.667 0 0 1-31.36 71.594h-33.11v232.363a42.667 42.667 0 0 1-42.666 42.666H555.52V738.816a42.667 42.667 0 0 0-37.675-42.368l-4.992-.299h-1.621a42.667 42.667 0 0 0-42.41 37.718l-.257 4.949v114.517H250.197a42.667 42.667 0 0 1-42.666-42.666V578.304h-33.11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol